import RicePreviewBridge from './src/RicePreviewBridge.vue';

RicePreviewBridge.install = function ( Vue ) {
    Vue.component(RicePreviewBridge.name,RicePreviewBridge);
}

export default RicePreviewBridge;


//////////////////
// WEBPACK FOOTER
// ./packages/RicePreviewBridge/index.js
// module id = null
// module chunks = 